import { createContext } from 'react'; 

const SaldosContext = createContext();

export default SaldosContext;